'use client'

import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { useTimeout } from 'ahooks'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import { HiCheckCircle, HiDocumentCheck, HiExclamationTriangle, HiInformationCircle, HiXCircle } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'
import { Button, Container, CruzIcon } from '@/components'
import { useGlobalStore } from '@/store/provider'

export function Toast() {
  const { toast, setToast } = useGlobalStore((state) => state)
  const [open, setOpen] = useState(false)
  const [delay, setDelay] = useState<number | undefined>(undefined)

  const clear = useTimeout(() => {
    setDelay(undefined)
    setOpen(false)
    setToast(null)
  }, delay)

  useEffect(() => {
    if (_.isEmpty(toast)) {
      setOpen(false)
    } else {
      setOpen(true)
    }
    if (toast?.type === 'success') {
      // setDelay(2000)
    }
  }, [toast])

  function close() {
    clear()
    setToast(null)
  }

  const { message, title, type } = toast || {}

  function getTitle() {
    if (title) return title
    if (type === 'success') return <span>Success</span>
    if (type === 'error') return <span>Error</span>
    if (type === 'info') return <span>Information</span>
    if (type === 'warning') return <span>Warning</span>
    if (type === 'sent') return <span>Sent</span>
    return ''
  }

  function renderIcon() {
    function getBg() {
      if (type === 'success') return 'bg-green-100 text-green-500 dark:bg-green-900 dark:text-green-400'
      if (type === 'error') return 'bg-red-100 text-red-500 dark:bg-red-900 dark:text-red-400'
      if (type === 'info') return 'bg-blue-100 text-blue-500 dark:bg-blue-900 dark:text-blue-400'
      if (type === 'warning') return 'bg-yellow-100 text-yellow-500 dark:bg-yellow-900 dark:text-yellow-400'
      if (type === 'sent') return 'bg-sky-100 text-sky-500 dark:bg-sky-900 dark:text-sky-400'
      return 'bg-gray-100 text-gray-500 dark:bg-gray-900 dark:text-gray-400'
    }
    function getIcon() {
      if (type === 'success') return <HiCheckCircle className='size-8' aria-hidden='true' />
      if (type === 'error') return <HiXCircle className='size-8' aria-hidden='true' />
      if (type === 'info') return <HiInformationCircle className='size-8' aria-hidden='true' />
      if (type === 'warning') return <HiExclamationTriangle className='size-8' aria-hidden='true' />
      if (type === 'sent') return <HiDocumentCheck className='size-8' aria-hidden='true' />
      return <CruzIcon.Close className='size-8' aria-hidden='true' />
    }
    return <div className={twMerge('rounded-full h-fit p-2 mt-2', getBg())}>{getIcon()}</div>
  }

  return (
    <Dialog autoFocus={false} open={open} onClose={close} className='relative z-40'>
      <DialogBackdrop className='dialog-backdrop' />
      <Container size='xs' className='fixed inset-0 z-20 flex min-h-full w-full items-center justify-center overflow-y-auto p-4'>
        <DialogPanel className='flex gap-x-6 rounded-lg bg-white w-full p-5 md:shadow-lg dark:bg-zinc-950'>
          {renderIcon()}
          <div className='grow'>
            <section className='flex items-center justify-between'>
              <h3 className='font-bold text-xl text-zinc-900 dark:text-white'>{getTitle()}</h3>
            </section>
            <p>{message || ''}</p>
            <div className='flex justify-end mt-2'>
              <Button type='button' onClick={close} className='h-10' tabIndex={-1}>
                Close
              </Button>
            </div>
          </div>
        </DialogPanel>
      </Container>
    </Dialog>
  )
}
